import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { DatabaseIcon, HardDriveIcon, CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function AppendixA3Slide() {
  return <SlideLayout data-id="element-58" data-mp="77ot6n0g3u3z">
      <motion.div variants={itemVariants} className="mb-12" data-id="element-59" data-mp="788dubhhcwlp">
        <p className="text-brand-teal font-mono text-xs tracking-widest uppercase mb-3" data-id="element-60" data-mp="c6rwa1wv7q9b">
          Appendix A3
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-61" data-mp="3tmhz4bq45oi9">
          Memory Architecture Advantage
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-62" data-mp="3knmqkszlk2bs">
        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8" data-id="element-63" data-mp="3kla17uriepop">
          <div className="flex items-center gap-3 mb-6" data-id="element-64" data-mp="3aox7iwvysbty">
            <div className="p-3 bg-brand-teal/10 rounded-lg border border-brand-teal/20" data-id="element-65" data-mp="3arjeovey0pbn">
              <HardDriveIcon className="w-6 h-6 text-brand-teal" data-id="element-66" data-mp="3fqe6unysvq8f" />
            </div>
            <h3 className="text-xl font-bold text-brand-text" data-id="element-67" data-mp="roc6aavegx64">
              Bare-Metal Operation
            </h3>
          </div>
          <ul className="space-y-4 text-brand-text-dim" data-id="element-68" data-mp="mt6p1pcy06od">
            <li className="flex items-start gap-3" data-id="element-69" data-mp="10paez6gs9sv1">
              <span className="text-brand-teal mt-1" data-id="element-70" data-mp="wp9m4gsxtf4g">•</span>
              <span data-id="element-71" data-mp="wprqk0pr6zng">
                100% of memory bandwidth reserved for model weights and KV cache
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-72" data-mp="40kt7521cg3s">
              <span className="text-brand-teal mt-1" data-id="element-73" data-mp="41vyxaf1jxxj">•</span>
              <span data-id="element-74" data-mp="hs91syd2smg0">
                No operating system, no virtual memory paging, no context
                switching
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-75" data-mp="cywkl9aq7hxa">
              <span className="text-brand-teal mt-1" data-id="element-76" data-mp="3lfrazpac79uh">•</span>
              <span data-id="element-77" data-mp="3hf7caha47y68">
                Every byte of bandwidth serves inference — zero overhead
              </span>
            </li>
          </ul>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8" data-id="element-78" data-mp="1keb9pywxmj28">
          <div className="flex items-center gap-3 mb-6" data-id="element-79" data-mp="1u4o0w9z95ahc">
            <div className="p-3 bg-brand-teal/10 rounded-lg border border-brand-teal/20" data-id="element-80" data-mp="1u566hx7t111x">
              <DatabaseIcon className="w-6 h-6 text-brand-teal" data-id="element-81" data-mp="1z2pmp2o2bnwi" />
            </div>
            <h3 className="text-xl font-bold text-brand-text" data-id="element-82" data-mp="11h0mjcokrg35">
              Custom Memory Hierarchies
            </h3>
          </div>
          <ul className="space-y-4 text-brand-text-dim" data-id="element-83" data-mp="16gn1bqk1x4e2">
            <li className="flex items-start gap-3" data-id="element-84" data-mp="1bcveiyeounil">
              <span className="text-brand-teal mt-1" data-id="element-85" data-mp="1gczsago7p454">•</span>
              <span data-id="element-86" data-mp="1gekmg56m6l2g">
                BRAM/URAM buffers sized for exact model access patterns
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-87" data-mp="2mvegh1s6sf5f">
              <span className="text-brand-teal mt-1" data-id="element-88" data-mp="2rqtubtq72b1u">•</span>
              <span data-id="element-89" data-mp="g4jn3w7mytyi">Multi-level caching tuned per layer, per operator</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-90" data-mp="b5q63tt54ktl">
              <span className="text-brand-teal mt-1" data-id="element-91" data-mp="b71de3lsoapg">•</span>
              <span data-id="element-92" data-mp="6egj70yz7vle">Data reuse maximized at every level of the hierarchy</span>
            </li>
          </ul>
        </motion.div>
      </div>

      {/* Key Stat */}
      <motion.div variants={itemVariants} className="bg-brand-bg-card border border-brand-teal/30 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-8 max-w-4xl mx-auto" data-id="element-93" data-mp="1dstqjqebmta">
        <div className="flex-shrink-0" data-id="element-94" data-mp="3omza07d4gew7">
          <div className="p-4 bg-brand-teal/10 rounded-xl border border-brand-teal/20" data-id="element-95" data-mp="3jkqeb38v6yqe">
            <CpuIcon className="w-10 h-10 text-brand-teal" data-id="element-96" data-mp="3emym084b5alo" />
          </div>
        </div>
        <div data-id="element-97" data-mp="1htwu22nxltc2">
          <div className="text-5xl font-bold text-brand-teal mb-2" data-id="element-98" data-mp="1huomx5q59cyn">3,136×</div>
          <p className="text-lg text-brand-text font-medium mb-1" data-id="element-99" data-mp="1cv29owabfwpu">
            Weight Reuse Factor
          </p>
          <p className="text-sm text-brand-text-dim" data-id="element-100" data-mp="ah4hv043ng32">
            Measured in FlightLLM benchmarks. Custom on-chip buffers allow each
            weight to be reused thousands of times before being evicted —
            dramatically reducing external memory traffic.
          </p>
        </div>
      </motion.div>
    </SlideLayout>;
}